module.exports = __webpack_public_path__ + "static/img/a4.a5fd82b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a4.png
// module id = 28
// module chunks = 1